const BASE = "";
const VERSION = process.env.REACT_APP_STORAGE_VERSION || "";

/**
 * Wrapper for sessionStorage that made storage key uniq for any base path.
 * It's required for multiple projects on the same domain but at different folders
 */
export abstract class Storage {
	/**
	 * Store key/value data in sessionStorage
	 */
	public static SET(key: string, value: unknown): void {
		const val = typeof value === "string" ? value : JSON.stringify(value || "");
		sessionStorage.setItem(Storage.generate_key(key), val);
	}

	/**
	 * Get value by key from sessionStorage
	 */
	public static GET(key: string) {
		return sessionStorage.getItem(Storage.generate_key(key));
	}

	/**
	 * Remove value by key from sessionStorage
	 */
	public static REMOVE(key: string): void {
		sessionStorage.removeItem(Storage.generate_key(key));
	}

	/**
	 * Remove all values from sessionStorage
	 */
	public static FLUSH(): void {
		sessionStorage.clear();
	}

	private static generate_key(key: string): string {
		return BASE + key + "-" + VERSION;
	}
}
